import React, { useCallback, useEffect, useState } from "react";

import moment from "moment";

import Profile from "../../assets/images/profile.png";

import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import { Badge } from "react-bootstrap";

import AuthService from "../../services/auth.service";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Form } from "react-bootstrap";

import Select from "react-select";
import HolidayShiftService from "../../services/holidayshift.service";
import { useStateContext } from "../../contexts/ContextProvider";

const UpdateLogHours = ({
  updateLoghours,
  setUpdateLoghours,
  selectedData,
  fetchCompoffData,
}) => {
  const user = AuthService.getCurrentUser();

  const [characterLimit] = useState(150);

  const [totalWorkingHours, setTotalWorkingHours] = useState("");
  const [actualWorkingHours, setActualWorkingHours] = useState("");

  const [validated, setValidated] = useState(false);

  const initialData = {
    project: "",
    module: "",
    assignee: "",
    desc: "",
    duration: "0",
    requestid: "",
  };

  const initialData2 = {
    date: "",
    formatedDate: "",
    fromTime: "",
    toTime: "",
    workinghrs: "",
  };

  const [details, setDetails] = useState(initialData);
  const [details2, setDetails2] = useState(initialData2);

  const [dates, setDates] = useState([]);

  const { employees, getNameInitials } = useStateContext();

  const [empOption, setEmpOption] = useState({});

  useEffect(() => {
    const filteredEmployees = employees.map((item) => ({
      label: item.name,
      value: item.empId,
    }));
    setEmpOption(filteredEmployees);
  }, [employees]);

  // console.log("selectedData", selectedData);

  useEffect(() => {
    if (updateLoghours) {
      setDetails((prev) => ({
        ...prev,
        project: selectedData && selectedData.projectid,
        module: selectedData && selectedData.module,
        assignee: selectedData && selectedData.assignee,
        desc: selectedData && selectedData.description,
        duration: selectedData && selectedData.workinghrs,
        requestid: selectedData && selectedData.reqdetails[0].requestid,
      }));
      const reqdetails =
        selectedData &&
        selectedData.reqdetails.map((item) => ({
          date: item.rdate,
          formatedDate: moment(new Date(item.rdate)).format("D MMM YYYY"),
          fromTime: item.fromtime,
          toTime: item.totime,
          workinghrs: item.workinghrs,
          actualHours: "00:00",
        }));
      setDates(reqdetails);
    }
  }, [updateLoghours, selectedData]);

  const [projects, setProjects] = useState([]);

  // const currentDate = new Date();

  const fetchProjects = useCallback(() => {
    HolidayShiftService.getListofProjects()
      .then((resp) => {
        if (resp.data) {
          const projectOptions = resp.data.map((item) => ({
            value: item.projectid,
            label: item.projectname,
          }));
          setProjects(projectOptions);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const calculateTimeDifference = (time1, time2) => {
    // console.log(time1, time2);
    time1 = time1 && time1.split(":");
    time2 = time2 && time2.split(":");

    var startDate = new Date(0, 0, 0, time1[0], time1[1], 0);
    var endDate = new Date(0, 0, 0, time2[0], time2[1], 0);

    var diff = endDate.getTime() - startDate.getTime();
    var hours = Math.floor(diff / 1000 / 60 / 60);
    diff -= hours * 1000 * 60 * 60;
    var minutes = Math.floor(diff / 1000 / 60);

    if (hours < 0) {
      hours = hours + 24;
    }

    return (
      (hours <= 9 ? "0" : "") +
      hours +
      ":" +
      (minutes <= 9 ? "0" : "") +
      minutes
    );
  };

  const handleInputRowChange = (e, row) => {
    const { name, value } = e.target;

    // console.log(name, value);

    if (name === "fromTime") {
      const hours = calculateTimeDifference(value, row.toTime);
      const newData = dates.map((item) =>
        item.date === row.date
          ? { ...item, fromTime: value, actualHours: hours }
          : item,
      );
      setDates(newData);
    } else if (name === "toTime") {
      const hours = calculateTimeDifference(row.fromTime, value);
      const newData = dates.map((item) =>
        item.date === row.date
          ? { ...item, toTime: value, actualHours: hours }
          : item,
      );
      setDates(newData);
    }
  };

  // console.log("dates", dates);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleInputChange2 = (e) => {
    const { name, value } = e.target;

    if (name === "fromTime") {
      const hours = calculateTimeDifference(value, details2.toTime);
      setDetails2((prevState) => ({
        ...prevState,
        fromTime: value,
        workinghrs: hours,
      }));
    } else if (name === "toTime") {
      const hours = calculateTimeDifference(details2.fromTime, value);
      setDetails2((prevState) => ({
        ...prevState,
        toTime: value,
        workinghrs: hours,
      }));
    }
  };

  const hideLeaveModal = (e) => {
    e.preventDefault();
    setUpdateLoghours(false);
  };

  const isValidHours = (hours) => {
    if (typeof hours !== "string") return false;
    const parts = hours.split(":");
    if (parts.length !== 2) return false;
    const [hoursPart, minutesPart] = parts;
    return `${!isNaN(hoursPart) && hoursPart}:${
      !isNaN(minutesPart) && minutesPart
    }`;
  };

  const calculateTotalWorkingHours = (totalMinutes) => {
    const totalHours = Math.floor(totalMinutes / 60);
    const remainingMinutes = totalMinutes % 60;

    const totalWorkingHours =
      (totalHours <= 9 ? "0" : "") +
      totalHours +
      ":" +
      (remainingMinutes <= 9 ? "0" : "") +
      remainingMinutes;

    return totalWorkingHours;
  };

  useEffect(() => {
    let totalMinutes = 0;
    let actualMinutes = 0;

    for (const time of dates) {
      const workinghrs = time.workinghrs;
      const [hours, minutes] = workinghrs.split(":").map(Number);
      totalMinutes += hours * 60 + minutes;
    }

    for (const time of dates) {
      const workinghrs = time.actualHours;
      const [hours, minutes] = workinghrs.split(":").map(Number);
      actualMinutes += hours * 60 + minutes;
    }

    const totalWorkingHours = calculateTotalWorkingHours(totalMinutes);
    const totalActualHours = calculateTotalWorkingHours(actualMinutes);

    setTotalWorkingHours(totalWorkingHours);
    setActualWorkingHours(totalActualHours);
  }, [dates]);

  const handleSubmit = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const form = e.currentTarget;

    if (form.checkValidity() === false || dates.length === 0) {
      setValidated(true);
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }

    const data = {
      empid: user && user.empid,
      projectid: details.project,
      module: details.module,
      description: details.desc,
      assignee: details.assignee,
      workduration: dates.length.toString(),
      requestid: details.requestid,
      reqdetails: dates.map((item) => ({
        rdate: item.date,
        fromtime: item.fromTime,
        totime: item.toTime,
      })),
    };

    // console.log(details);
    // console.log(data);

    HolidayShiftService.editHolidayShift(data)
      .then((resp) => {
        if (resp.data) {
          setDetails(initialData);
          setDates([]);
          setDetails2(initialData2);
          fetchCompoffData();
          toast.success("Holiday Shift Updated Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            onClose: () => setUpdateLoghours(false),
          });
        }
      })
      .catch((e) => console.log(e));
  };

  const addRow = () => {
    // console.log(Object.values(details2).every((value) => value !== ""));
    if (Object.values(details2).every((value) => value !== "")) {
      setDates((prevState) => [...prevState, details2]);
      setDetails2(initialData2);
    } else {
      toast.warn("* Please fill all required fields!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  };

  const removeRow = (date) => {
    // console.log(date);
    const filteredData = dates.filter((item) => item.date !== date);
    // console.log(filteredData);
    setDates(filteredData);
  };

  return (
    <>
      <div
        className={`${
          updateLoghours ? "applyLeaveModal visible" : "applyLeaveModal hidden"
        }`}
      >
        <div className="filter-flex">
          <ToastContainer />
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <div className="sort-list">
              <div className="leaveModalHeading">
                <div className="row">
                  <div className="col-lg-6">
                    <div className="left-flex">
                      <div className="heading">
                        <span>Add Log Hours </span>
                      </div>
                      <div className="profile">
                        {user && user.profile ? (
                          <img src={Profile} width={50} alt="" />
                        ) : (
                          <>
                            <div className="circle">
                              <span>
                                {getNameInitials(user && user.userName)}
                              </span>
                            </div>
                          </>
                        )}

                        <div className="profile-info">
                          <span className="name">{user && user.userName}</span>
                          <span className="desig">
                            {user && user.designation}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="balance">
                      <div className="right">
                        <div className="flex">
                          <span>Applied For:</span>
                          <span className="count">
                            {Array.isArray(dates) && dates.length} Days
                          </span>
                        </div>
                        <div className="flex">
                          <span>Work Hours:</span>
                          <span className="count">
                            {isValidHours(totalWorkingHours)} Hrs
                          </span>
                        </div>
                        <div className="flex">
                          <span>Actual Work Hours:</span>
                          <span className="count">
                            {isValidHours(actualWorkingHours)} Hrs
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="leaveModalBody">
                <div className="row">
                  <div className="col-lg-4">
                    <div className="mb-3 calendar-relative">
                      <label htmlFor="leaveType" className="form-label">
                        Project
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedData.project}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 ps-0">
                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Module
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Module Name"
                        name="module"
                        value={details.module}
                        readOnly
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 ps-0">
                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Assignee name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        value={selectedData.assigneename}
                        readOnly
                      />
                    </div>
                  </div>
                </div>

                {Array.isArray(dates)
                  ? dates.length > 0 && (
                      <div className="">
                        <label htmlFor="leaveType" className="form-label">
                          Applied Dates
                        </label>
                      </div>
                    )
                  : null}

                {Array.isArray(dates)
                  ? dates.map((item) => {
                      return (
                        <div className="row">
                          <div className="col-lg-3">
                            <div className="mb-3 calendar-relative">
                              <label htmlFor="leaveType" className="form-label">
                                Date
                              </label>
                              <div className="date-input">
                                <span>{item.formatedDate}</span>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-9">
                            <div className="row">
                              <div className="col-lg-3 ps-0">
                                <div className="mb-3 calendar-relative">
                                  <label
                                    htmlFor="leaveType"
                                    className="form-label"
                                  >
                                    From Time *
                                  </label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="fromTime"
                                    value={item.fromTime}
                                    onChange={(e) =>
                                      handleInputRowChange(e, item)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 ps-0">
                                <div className="mb-3">
                                  <label
                                    htmlFor="leaveType"
                                    className="form-label"
                                  >
                                    To Time *
                                  </label>
                                  <input
                                    type="time"
                                    className="form-control"
                                    name="toTime"
                                    value={item.toTime}
                                    onChange={(e) =>
                                      handleInputRowChange(e, item)
                                    }
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 ps-0">
                                <div className="mb-3 calendar-relative">
                                  <label
                                    htmlFor="leaveType"
                                    className="form-label"
                                  >
                                    Working Hours
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="fromTime"
                                    value={item.workinghrs}
                                    readOnly
                                  />
                                </div>
                              </div>
                              <div className="col-lg-3 ps-0">
                                <div className="mb-3 calendar-relative">
                                  <label
                                    htmlFor="leaveType"
                                    className="form-label"
                                  >
                                    Actual Hours
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    name="fromTime"
                                    value={item.actualHours}
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  : null}

                <div className="row">
                  <div className="col-lg-12">
                    <div className="mb-3">
                      <label htmlFor="leaveType" className="form-label">
                        Description
                      </label>
                      <textarea
                        className="form-control"
                        name="desc"
                        value={details.desc}
                        onChange={handleInputChange}
                      ></textarea>
                      <Badge
                        className="mt-3"
                        bg={`${
                          details.desc && details.desc.length > characterLimit
                            ? "danger"
                            : "success"
                        }`}
                      >
                        {details.desc && details.desc.length}/{characterLimit}
                      </Badge>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="sort-action">
              <button className="btn btn-reset" onClick={hideLeaveModal}>
                Cancel
              </button>
              <button className="btn btn-apply">Update</button>
            </div>
          </Form>
        </div>
      </div>
    </>
  );
};

export default UpdateLogHours;
